import React, { useState } from 'react';
import axios from 'axios';
import "./ForgetPassword.css";
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import blueLock from "../../assets/images/svg/blueLock.svg";

const ForgetPassword = ({ url }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const sendEmail = async () => {
        if (!email) {
            alert('Please enter your email');
            return;
        }
    
        try {
            const formData = new FormData();
            formData.append("cmd", "frappe.core.doctype.user.user.reset_password");
            formData.append("user", email);
            formData.append("send_code", "true");
    
            const response = await axios.post(url, formData);

            if (response.status === 200) { 
                navigate(`/newpassword/${email}`);
            }
    
            console.log("Response:", response.data);
        } catch (error) {
            console.error("Error sending email:", error);
        }
    };

    return (
        <div className='auth'>
            <div className='check-email-container'>
                <Container>
                    <div className='reset-password-image'>
                        <img src={blueLock} alt='Lock' />
                    </div>
                    <input
                        type='email'
                        className='login-field user-field'
                        placeholder='Enter your email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    
                    <button 
                        className='login-submit' 
                        onClick={sendEmail}
                    >
                        Submit
                    </button>
                </Container>
            </div>
        </div>
    );
};

export default ForgetPassword;
